"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var csrfSafeMethod = void 0;

var getCookie = void 0;
var runSetup = void 0;

getCookie = require("./get_cookie").default;

csrfSafeMethod = function csrfSafeMethod(method) {
	return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method)
	);
};

runSetup = function runSetup() {
	var csrfToken = void 0;
	csrfToken = getCookie(window.csrfCookieName);
	return _jquery2.default.ajaxSetup({
		beforeSend: function beforeSend(xhr, _ref) {
			var type = _ref.type;

			if (!csrfSafeMethod(type) && !this.crossDomain) {
				return xhr.setRequestHeader("X-CSRFToken", csrfToken);
			}
		}
	});
};

exports.default = runSetup;